export const ACTIVE_ICON_SIZE = [46.7, 72];
export const ACTIVE_ICON_OFFSET = [-23.5, -72];
export const DEFAULT_ICON_SIZE = [38.92, 60];
export const DEFAULT_ICON_OFFSET = [-19.5, -60];

export const ZOOM_MIN_VALUE = 8;
export const ZOOM_MAX_VALUE = 16;
